import { render, staticRenderFns } from "./NatconPaymentCreate.vue?vue&type=template&id=c06ab4e2"
import script from "./NatconPaymentCreate.vue?vue&type=script&lang=js"
export * from "./NatconPaymentCreate.vue?vue&type=script&lang=js"
import style0 from "./NatconPaymentCreate.vue?vue&type=style&index=0&id=c06ab4e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports